import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import './icon-uploader.less'
import { notifyAlert } from './notification'

class IconUploadAndSelect extends React.Component {
  static  propTypes = {
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    mbSize: PropTypes.number,
    onUpload: PropTypes.func,
    onSuccess: PropTypes.func,
    onFailure: PropTypes.func,
    fetchAddCustomIcon: PropTypes.func,
    fetchCustomIconList: PropTypes.func,
    exts: PropTypes.array,
    onSelected: PropTypes.array,
    type: PropTypes.string,
    icon_type: PropTypes.number,
    style: PropTypes.object,
    rowNumber: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      icons: [],
      showNotice: false,
      selected: ''
    }
  }

  componentDidMount() {
    this._getIcons()
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(this.state, nextState)
  }

  render() {
    const { maxWidth, maxHeight, rowNumber } = this.props
    const { icons, showNotice, selected } = this.state
    const exts = this.getExts().map(e => e.replace('.', '')).join('、')

    return (
      <div className="icon-uploader" style={{ ...this.props.style }}>
        <div className="list-box">
          <div className={`upload-notice ${showNotice ? 'show' : ''}`}
            onMouseEnter={() => this.setState({ showNotice: true })}
            onMouseLeave={() => this.setState({ showNotice: false })}>
            <i className="dmpicon-help i-pos"></i>{`仅支持上传${exts}格式,最大尺寸${maxWidth}*${maxHeight}px`}
          </div>
          <ul className="icon-list">
            <li className="icon-block add-custom-icon"
              onMouseEnter={() => this.setState({ showNotice: true })}
              onMouseLeave={() => this.setState({ showNotice: false })}>
              <div className="wrap-icon-item">
                <div className="action-sign"></div>
              </div>
              <input
                className="upload-action-target"
                onChange={this.beforeUpload.bind(this)}
                type="file"
                ref={(node) => { this.file_ref = node }}
                accept="image/png,image/gif,image/jpeg,image/x-ms-bmp,image/bmp,image/svg"
              />
            </li>
            {icons.slice(0).reverse().map((icon, index) => {
              const selectedClassName = icon === selected ? 'selected' : ''
              const lastClassName = (index + 2) % (rowNumber || 6) === 0 ? 'last' : ''
              const urlIconStyle = {
                backgroundImage: `url(${icon.icon_url})`,
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain'
              }
              return <li key={index} className={`icon-block icon-show ${selectedClassName} ${lastClassName}`} onClick={this.selectIcon.bind(this, icon)}>
                <div className="src-icon" style={urlIconStyle} title={icon.name}></div>
              </li>
            })
            }
          </ul>
        </div>
      </div>
    )
  }

  // 获取 ICON 数据
  _getIcons() {
    const icon_type = this.props.icon_type || 2
    this.props.fetchCustomIconList(icon_type, (json) => {
      if (json.result) {
        this.setState({
          icons: json.data
        })
      } else {
        this.handleError('获取 Icons 列表失败', json.msg)
      }
    })
  }

  handleError(errText) {
    notifyAlert('', errText, 'error')
  }

  handleSuccess(icon) {
    this.setState({
      icons: [...this.state.icons, icon]
    })
    notifyAlert('', '上传成功！', 'success')
  }

  selectIcon(icon) {
    const { onSelected } = this.props
    this.setState({
      selected: icon
    }, () => {
      _.isFunction(onSelected) && onSelected(icon)
    })
  }

  // 上传前的处理
  beforeUpload(e) {
    // 1、验证文件是否符合大小
    // 2、后缀是否是支持类型
    // 3、长宽是否符合
    const { maxWidth, maxHeight } = this.props
    const exts = this.getExts().map(d => d.replace('.', '')).join('、')
    const files = e.target
    if (!!files.value && this._validateFileSize(files) && this._validateFileExt(files.value)) {
      const file = files.files[0]
      const img = new Image()
      img.src = URL.createObjectURL(file)
      img.onload = () => {
        const { width, height } = img
        if (width > maxWidth || height > maxHeight) {
          this.handleError(`上传失败, 仅支持${exts}格式, 最大尺寸${maxWidth}*${maxHeight}px, 请稍后重试。`)
        } else {
          this.onUploadImage(file)
        }
        URL.revokeObjectURL(img.src)
      }
      img.onerror = (err) => {
        this.handleError(`图片上传失败！${err.msg}`)
        URL.revokeObjectURL(img.src)
      }
    }
  }

  onUploadImage(file) {
    const { onUpload, type, icon_type } = this.props

    if (file) {
      const fData = new FormData()
      fData.append('image_file', file)

      onUpload(fData, (json) => {
        if (json.result) {
          const payload = {
            name: `${file.name.split('.')[0]}-${Date.now()}`,
            icon_url: json.data,
            icon_type: icon_type || 2,
            description: type
          }
          this.props.fetchAddCustomIcon(payload, (data) => {
            if (data.result) {
              this.handleSuccess({ ...payload, ...data })
            } else {
              this.handleError(`图片上传失败！${data.msg}`)
            }
          })
        } else {
          this.handleError(`图片上传失败！${json.msg}`)
        }
      })
    }
  }

  getExts() {
    const { exts } = this.props
    return _.isArray(exts) && exts.length > 0 ? exts : ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.svg']
  }

  // 校验文件大小
  _validateFileSize(file) {
    const { mbSize } = this.props

    if (mbSize <= 0) {
      return true
    }

    let isValidSize = false

    if (this._isMSIE()) {
      const img = new Image()
      img.src = file.value
      isValidSize = img.fileSize < mbSize * 1024 * 1024
    } else {
      isValidSize = file.files[0].size < mbSize * 1024 * 1024
    }

    if (!isValidSize) {
      if (mbSize < 1) {
        this.handleError(`文件应小于（ ${mbSize * 1000}KB ）！`)
      } else {
        this.handleError(`文件应小于（ ${mbSize}MB ）！`)
      }
    }

    return isValidSize
  }

  // 检验文件 后缀
  _validateFileExt(fileName) {
    const ext = this.getExts()
    const { maxWidth, maxHeight } = this.props

    // 截取后缀
    const _ext = fileName.substring(fileName.lastIndexOf('.'), fileName.length).toLowerCase()
    // 是否为有效后缀
    const isValidExt = ext.indexOf(_ext) > -1

    const ext_msg = ext.map(item => item.substr(1)).join('、')

    if (!isValidExt) {
      this.handleError(`上传失败, 仅支持${ext_msg}格式, 最大尺寸${maxWidth}*${maxHeight}px, 请稍后重试。`)
    }

    return isValidExt
  }

  _isMSIE() {
    return navigator.userAgent.indexOf('MSIE') >= 0
  }
}

export default IconUploadAndSelect
